import {md5} from "js-md5";

export * from "@shared/utils/Util";

export async function getFileMD5(file: File) {
    return md5(await file.arrayBuffer());
}
